<template>
  <div class="excellent-works">
    <a-carousel :after-change="onChange" v-if="bannerData!=null && bannerData.length>0">
      <img
          :src="img.image"
          v-for="(img, index) of bannerData"
          :key="index"
          class="course-img"
      />
    </a-carousel>
    <div class="course">
      <div class="excellent-works">
        <div class="course-title">推荐</div>
        <div class="tabs-wrapper">
          <!--          分类-->
          <div class="tabs-box">
            <span style="background: #F8F8F8;border:1px solid #F8F8F8;">分类</span>
            <span :class="{ 'box-active': categoryKey===0 }" @click="handleCategoryActive(0)">全部</span>
            <span
                :class="{ 'box-active': tab.id === categoryKey }"
                v-for="(tab, index) in categoryData"
                :key="index"
                @click="handleCategoryActive(tab.id)"
            >{{ tab.typeName }}</span
            >
          </div>
          <!--          板块-->
          <div class="tabs-box" v-if="0">
            <span style="background: #F8F8F8;border:1px solid #F8F8F8;">阶段</span>
            <span :class="{ 'box-active': plateKey===0 }" @click="handlePlateActive(0)">不限</span>
            <span
                :class="{ 'box-active': tab.id === plateKey }"
                v-for="(tab, index) in plateData"
                :key="index"
                @click="handlePlateActive(tab.id)"
            >{{ tab.name }}</span>
          </div>
        </div>

      </div>
    </div>

    <div class="excellent-works-list">
      <!--      课程排序-->
      <div class="tabs-box-sort" v-if="0">
        <span
            :class="{ 'box-active': tab.id === sortKey }"
            v-for="(tab, index) in sortList"
            :key="index"
            @click="handleSortActive(tab.id)"
        >{{ tab.name }}</span
        >
      </div>
      <!--      课程列表-->
      <div class="box-wrapper">
        <div
            class="box"
            v-for="(art, index) in courseData"
            :key="index"
            @click="handleClickToCourseDetails(art.id)"
        >
          <img :src="art.imageUrl" alt="" />
          <div class="content">
            <div class="topic">{{ art.title }}</div>
            <div class="teacher">
              <span :style="'padding:0px 5px;color:#ffffff;border-radius: 3px;background:'+art.plateColor" v-if="art.plateName">{{ art.plateName }}</span>
              {{art.categoryName}} | {{ art.lessonNum }} 节</div>
            <div class="info">
              <span class="free" v-if="art.price==0">免费</span>
              <span class="price" v-if="art.price>0">
                <em>￥</em><strong>{{ art.price }}</strong>
              </span>
              <!--              <span class="course-time">{{art.courseTime|TotalTimeFilter}}</span>-->
              <span v-if="art.teacherVos!=null&&art.teacherVos.length>0">
                <img :src="art.teacherVos[0].imageUrl" class="img-teacher" > {{art.teacherVos[0].fullName}}
              </span>
            </div>
          </div>
        </div>
        <div v-if="courseData.length==0" class="no-show-msg">暂无信息</div>
      </div>

      <!--      分页-->
      <div class="tabs-page">
        <em @click="changePage(false)">
          上一页
          <img src="@/assets/img/arrow-l.png" alt=""/>
        </em>
        <span>{{ excellentWorksParams.page }}</span
        >/<span>{{ excellentWorksParams.totalPage }}</span>
        <em @click="changePage(true)">
          <img src="@/assets/img/arrow-r.png" alt=""/>
          下一页
        </em>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "./components/TabsModule.vue";
import {bannerAreaList, artCourseList, courseList} from "@/api/CourseCenter";
import {plateList, categoryList} from "@/api/Category";

export default {
  name: "CourseCenter",
  components: {
    // Tabs,
  },
  data() {
    return {
      plateKey: 0,
      categoryKey:0,
      sortKey:0,
      bannerData: [],
      plateData: [],
      categoryData: [],
      sortList:[{name:'默认排序',id:'0'},{name:'最新',id:'1'},{name:'免费',id:'2'},{name:'点击量',id:'3'}],
      courseData: [],
      params: {
        limit: 10,
        page: 0,
      },

      total:0,
      excellentWorksParams: {
        categoryId: "",
        plateId: "",
        limit: 12,
        page: 1,
        totalPage: 0,
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    onChange(a, b, c) {
      console.log(a, b, c);
    },
    getInfo() {
      // bannerAreaList({area: 2, num: 1}).then((res) => {
      //   this.bannerData = res.data;
      // })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      plateList()
          .then((res) => {
            this.plateData = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      categoryList()
          .then((res) => {
            this.categoryData = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      this.artCourseListFunc(this.excellentWorksParams);
    },
    artCourseListFunc(params) {
      courseList(params)
          .then((res) => {
            this.courseData = res.data;
            this.excellentWorksParams.totalPage = res.totalPage;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    handlePlateActive(index){
      this.plateKey = index;
      this.excellentWorksParams.plateId=index;
      this.artCourseListFunc(this.excellentWorksParams);
    },
    handleCategoryActive(index) {
      this.categoryKey = index;
      this.excellentWorksParams.categoryId=index;
      this.artCourseListFunc(this.excellentWorksParams);
    },
    handleSortActive(index){
      this.sortKey = index;
      switch(index){
        case 1:this.excellentWorksParams.isNew=1;break;
        case 2:this.excellentWorksParams.priceOrder='asc';break;
        case 3:this.excellentWorksParams.clickName='asc';break;
      }
      this.artCourseListFunc(this.excellentWorksParams);
    },
    handleClickToCourseDetails(id) {
      this.$router.push({
        name: "CourseDetail",
        params: {
          id,
        },
      });
    },
    changePage(flag) {
      // 下一页
      if (flag) {
        if (this.excellentWorksParams.page === this.excellentWorksParams.totalPage) {
          return;
        }
        this.excellentWorksParams.page = this.excellentWorksParams.page + 1;
      } else {
        if (this.excellentWorksParams.page === 1) {
          return;
        }
        this.excellentWorksParams.page = this.excellentWorksParams.page - 1;
      }
      this.artCourseListFunc(this.excellentWorksParams);
    },
  },
};
</script>
<style lang="scss">
.excellent-works {
  .course-img {
    height: 415px;
  }

  /* 框架格式化样式 */
  .slick-slide {
    text-align: center;
    height: 160px;
    line-height: 160px;
    background: #364d79;
    overflow: hidden;
  }

  .slick-slide h3 {
    color: #fff;
  }
}
.course {
  // height: 866px;
  margin: 0 auto;
  background: #F8F8F8;
  width:100%;
  .excellent-works{
    margin: 0 auto;
    width:1280px;
    .course-title{
      padding:30px 0 20px 0;
      font-size: 48px;
      color:#DA514E;
    }
    .tabs-wrapper {
      margin: 0 auto;
      height: 100px;
      .tabs-box {
        margin: 0 auto;
        width: 1280px;
        //display: flex;
        //justify-content: space-around;
        line-height: 42px;
        span {
          border-radius: 5px;
          border:1px solid #fff;
          margin-left: 0;
          margin-right: 11px;
          padding: 3px 10px;
          flex-grow: 1;
          font-size: 15px;
          background: #fff;
        }
        .box-active {
          background: #DF764533;
          //border-bottom: 3px solid #da514e;
          //color: #da514e;
        }
      }
    }

  }
}
.excellent-works-list {
  margin: 0 auto;
  width: 1280px;
  .tabs-box-sort {
    margin: 20px auto;
    width: 1280px;
    //line-height: 22px;
    span {
      color: #333;
      border-radius: 5px;
      //border:1px solid #DDDDDD;
      margin-left: 0;
      margin-right: 11px;
      padding: 2px 10px;
      flex-grow: 1;
      font-size: 15px;
      background: #ffffff;
    }
    .box-active {
      background: #DDDDDD;
    }
  }
  .box-wrapper {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin-right: -20px;
    padding: 0;

    .no-show-msg{
      margin: 10px auto;
      font-size: 18px;
    }
  }
  .box {
    border-radius: 10px;
    margin: 0 20px 26px 0;
    width: 305px;
    height: 290px;
    box-shadow: 0px 0px 8px 5px rgb(0 0 0 / 9%);
    cursor: pointer;
    transition: 1s;
    &:hover {
      box-shadow: 0px 2px 8px 8px rgb(0 0 0 / 20%);
      transform: scale(1.02);
    }
    img {
      border-radius: 10px 10px 0 0;
      width: 305px;
      height: 171px;
    }
    .content {
      padding: 0 12px 0 14px;
      .topic {
        line-height: 41px;
        font-size: 15px;
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .teacher {
        line-height: 29px;
        color: #7f7f7f;
      }
      .info {
        padding: 14px 0 20px;
        line-height: 15px;
        color: #7f7f7f;
        display: flex;
        justify-content: space-between;
        .free {
          color: #3fbce9;
        }
        .price {
          color: #d9001d;
        }
        .img-teacher {
          margin-top: -3px;
          margin-right: 3px;
          width: 25px;
          height: 25px;
          border-radius: 50%;
        }
        .course-time {
          background: url("~@/assets/img/course-time.png") no-repeat;
          background-size: 15px 15px;
          text-indent: 20px;
        }
      }
    }
  }

  .tabs-page {
    padding: 24px 0 73px;
    text-align: center;
    user-select: none;

    em {
      cursor: pointer;
    }

    img {
      width: 46px;
      height: 35px;
      margin: 0 19px;
    }

    span {
      font-size: 15px;
    }

    span:nth-of-type(1) {
      margin-right: 6px;
      color: #2d3f51;
    }

    span:nth-of-type(2) {
      margin-left: 6px;
      color: #aaa;
    }
  }
}
</style>
